<ul class="row-container">
    <div class="alarm-row text">
        <li class="td font">
            <div>
                {{ alarm.channel }}
            </div>
        </li>
        <li class="td font">
            <div>{{ alarm.name }}</div>
        </li>
        <li class="td td-status font">
            <app-alarm-status-icon
                [statusText]="alarm.level"
            ></app-alarm-status-icon>
            <div class="font">{{ alarm.status }}</div>
        </li>
        <li class="td font">
            <div>{{ alarm.value }}</div>
        </li>
        <li class="td font">{{ alarm.category }}</li>
        <li class="td td-date font">
            <div>
                {{ alarm.occurrenceAt | date: "yyyy/MM/dd" }}
            </div>
            <div>
                {{ alarm.occurrenceAt | date: "HH:mm:ss" }}
            </div>
        </li>
        <li class="td td-date font">
            <div>
                {{ alarm.recoveryTime | date: "yyyy/MM/dd" }}
            </div>
            <div>
                {{ alarm.recoveryTime | date: "HH:mm:ss" }}
            </div>
        </li>
        <li class="td"></li>
    </div>
</ul>
